<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M3.51028 2.54359L5.08717 4.11361L4.11361 5.08717L2.54359 3.51028L0.973556 5.08717L0 4.11361L1.57689 2.54359L0 0.973556L0.973556 0L2.54359 1.57689L4.11361 0L5.08717 0.973556M14 9.88639L13.0264 8.91283L11.4564 10.4897L9.88639 8.91283L8.91283 9.88639L10.4897 11.4564L8.91283 13.0264L9.88639 14L11.4564 12.4231L13.0264 14L14 13.0264L12.4231 11.4564M12.7591 3.45544L10.5514 6.3144L9.46817 5.44368L10.2703 4.41528C9.24718 4.62312 8.29274 5.08494 7.49483 5.75825C6.69691 6.43157 6.08115 7.29475 5.70421 8.26837C6.30095 8.6987 6.72427 9.32811 6.89781 10.0431C7.07134 10.758 6.98366 11.5115 6.6506 12.1675C6.31753 12.8235 5.76099 13.3389 5.08138 13.6207C4.40177 13.9025 3.64383 13.9322 2.94427 13.7043C2.24471 13.4765 1.6496 13.0062 1.26628 12.3782C0.882952 11.7503 0.736657 11.006 0.853779 10.2796C0.9709 9.55329 1.34373 8.89272 1.90501 8.41706C2.46629 7.94141 3.17908 7.68199 3.91479 7.6856C4.09441 7.68633 4.27353 7.7047 4.44956 7.74045C4.92456 6.56165 5.68299 5.51821 6.65766 4.70259C7.63233 3.88698 8.79314 3.32438 10.0372 3.06464L9.05681 2.32419L9.92752 1.24094M5.6288 10.7708C5.6288 10.4318 5.52827 10.1004 5.33993 9.81856C5.1516 9.5367 4.88391 9.31701 4.57071 9.18728C4.25752 9.05755 3.91289 9.02361 3.5804 9.08974C3.24792 9.15588 2.94251 9.31912 2.7028 9.55883C2.4631 9.79854 2.29985 10.1039 2.23372 10.4364C2.16758 10.7689 2.20153 11.1135 2.33125 11.4267C2.46098 11.7399 2.68067 12.0076 2.96254 12.196C3.24441 12.3843 3.57579 12.4848 3.91479 12.4848C4.36937 12.4848 4.80534 12.3042 5.12678 11.9828C5.44821 11.6614 5.6288 11.2254 5.6288 10.7708Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'InviteTeamIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
    viewBox: {
      type: String,
      default: '0 0 14 14',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
